package org.hs_soft.runmynesto.pages.home.sub_page.customer_card.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.web.events.SyntheticMouseEvent
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.LoyaltyCardTypeEnum
import org.hs_soft.runmynesto.domain.model.home.customer_card.tabs.card.TelephoneCodeEnum
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomRadioInput
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.LoadingProgress
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.hs_soft.runmynesto.pages.components.dialog.component.DialogTitle
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.RadioGroup

@Composable
fun AddNewCustomerCardDialog(
    onCancelClick:()->Unit,
    onSubmitClick:(cardType:LoyaltyCardTypeEnum, String, String)->Unit,
    loading:Boolean,
)
{
    val selectedLoyaltyCardType= remember { mutableStateOf(LoyaltyCardTypeEnum.RFID) }
    val selectedCountryCode = remember { mutableStateOf(TelephoneCodeEnum.SWITZERLAND) }
    val phoneNumber= remember { mutableStateOf("") }
    val cardName= remember { mutableStateOf("") }

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onCancelClick()
            }
    ){

        Column(
            modifier = Modifier
                .onClick {
                    event: SyntheticMouseEvent -> event.stopPropagation()
                }
                .align(Alignment.Center)
                .width(Dimen.addNewCustomerWidth)
                .height(Dimen.addRecordDialogHeight)
                .generalDialogSetting()
            ,
            horizontalAlignment = Alignment.CenterHorizontally
        ){

            DialogTitle(
                title = Strings.current().addNewCustomerCard,
            )

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .fillMaxHeight()
                    .padding(Dimen.extraLargePadding),
                horizontalAlignment = Alignment.Start,
            ){
                CustomEditText(
                    modifier = Modifier ,
                    label = Strings.current().cardName,
                    value ="",
                    fillMaxWidth = true,
                    hasLabelSpace = false,
                    marginBottom = Dimen.smallPadding,
                    isRequired = selectedLoyaltyCardType.value==LoyaltyCardTypeEnum.DIGITAL,
                    hint = "",
                    onFocusIn = {},
                    onFocusOut = {

                    },
                    onInputChange = {it, validation ->
                        cardName.value=it
                    },
                )


                TelephoneInfo(
                    selectedCountryCode=selectedCountryCode,
                    selectedCustomerCardType=selectedLoyaltyCardType,
                    phoneNumber=phoneNumber
                )


                ChooseCustomerCardType(
                    selectedCustomerCardType=selectedLoyaltyCardType
                )

                Spacer()

                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .margin(top = Dimen.normalPadding),
                    horizontalArrangement = Arrangement.SpaceBetween,
                )
                {
                    CustomButton(
                        modifier = Modifier,
                        title = Strings.current().cancel,
                        width = Dimen.mediumSubmitButtonWidth,
                        buttonType = ButtonTypes.OUTLINED,
                        onButtonClick = {
                            onCancelClick()
                        }

                    )



                    CustomButton(
                        modifier = Modifier,
                        title = Strings.current().submit,
                        width = Dimen.mediumSubmitButtonWidth,
                        buttonType = ButtonTypes.CONTAINED,
                        isClickable = isButtonClickable(
                            selectedLoyaltyCardType=selectedLoyaltyCardType,
                            phoneNumber=phoneNumber,
                            cardName=cardName
                        ),
                        onButtonClick = {
                            onSubmitClick(
                                selectedLoyaltyCardType.value,
                                cardName.value,
                                "${selectedCountryCode.value.code}${phoneNumber.value}",
                            )
                        }

                    )
                }
            }




        }


        if (loading){
            LoadingProgress(
                visibility = loading,
                modifier = Modifier
                    .zIndex(2)
                    .borderRadius(
                        Dimen.lowBorderRadius
                    )
            )
        }




    }




}

private fun isButtonClickable(
    selectedLoyaltyCardType: MutableState<LoyaltyCardTypeEnum>,
    phoneNumber: MutableState<String>,
    cardName: MutableState<String>
) = if (selectedLoyaltyCardType.value == LoyaltyCardTypeEnum.RFID) {
    (phoneNumber.value.isNotEmpty())
} else {
    (phoneNumber.value.isNotEmpty() && cardName.value.isNotEmpty())
}


@Composable
private fun TelephoneInfo(
    selectedCountryCode: MutableState<TelephoneCodeEnum>,
    selectedCustomerCardType: MutableState<LoyaltyCardTypeEnum>,
    phoneNumber: MutableState<String>
) {
    Row(
        modifier = Modifier
            .margin(bottom = Dimen.smallPadding)
            .fillMaxWidth()
        ,
        verticalAlignment = Alignment.CenterVertically
    ) {
        DropDownItem(
            modifier = Modifier
                .margin(right = Dimen.mediumPadding),
            itemWidth = Dimen.extraSmallEditTextWidth,
            options = TelephoneCodeEnum.entries,
            label = Strings.current().tel,
            selectedItem =
                TelephoneCodeEnum.entries.find {
                    it.code == selectedCountryCode.value.code
                }?:TelephoneCodeEnum.SWITZERLAND,
            displayText = { item ->
                if (item is TelephoneCodeEnum) item.code else ""
            },
            onOptionClick = {
                selectedCountryCode.value = it
            }
        )
        CustomEditText(
            modifier = Modifier,
            fillMaxWidth = true,
            marginLeft = Dimen.largePadding,
            label = "",
            marginBottom =0.px ,
            value = "",
            isDecimal = true,
            isRequired = selectedCustomerCardType.value == LoyaltyCardTypeEnum.DIGITAL,
            hint = "",
            onFocusIn = {

            },
            onFocusOut = {},
            onInputChange = {it, validation ->
               phoneNumber.value=it
            },
        )
    }
}



@OptIn(ExperimentalComposeWebApi::class)
@Composable
private fun ChooseCustomerCardType(
    selectedCustomerCardType: MutableState<LoyaltyCardTypeEnum>
) {
    Column()
    {
        RadioGroup(selectedCustomerCardType.value.title) {
            LoyaltyCardTypeEnum.entries.forEach { filter ->
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.margin(topBottom = Dimen.smallPadding)
                )
                {
                    CustomRadioInput(
                        title = filter.title,
                        checked = filter==selectedCustomerCardType.value,
                        onClick = {
                            if (filter != selectedCustomerCardType.value)
                                selectedCustomerCardType.value = filter
                        },

                    )

                }


            }
        }
    }
}